import { getIsInWishList, WishlistItem } from 'features/shopping-list';
import { ADD_TO_SHOPPING_LIST_REQUEST } from 'features/shopping-list/ducks/shopping-list';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { ActionType, createAction } from 'typesafe-actions';
import {
  CompareCategory,
  selectCompareCategory,
  selectProductBrand,
  selectProductPriceCategory,
} from 'features/product-info';
import {
  selectProductBelong,
  selectProductDiscount,
  selectProductName,
  selectProductPrice,
  selectProductPricePrevious,
} from './selectors';

/**
 * Cобытие должно срабатывать при добавлении товара в список покупок.
 *
 * @see https://docs.google.com/document/d/1Y_vg_aaS7COYvoc4daxezKkWJUiH2Wn-hLAJ9D2ziac/edit#
 */
export const gaAddToShoppingList = createAction('GA:addToShoppingList')<{
  elementType: 'button';
  elementBlock: 'productDetail'; // блок, в котором расположен элемент
  elementName: 'shoppingList';
  productTag?: string | null;
  productName: string; // название товара
  productId: string; // артикул товара
  productPrice: string; // стоимость единицы товара
  productBelong: 'LeroyMerlin' | 'LeroyMerlinMarketplace' | 'Longtail'; // принадлежность товара: LeroyMerlinMarketplace - для товаров Маркетплейс, Longtail - для товаров longtail, LeroyMerlin - для товаров Леруа Мерлен
  productPrevPrice: string | null;
  productDiscount: number | null;
  brand?: string | null;
  category?: string;
}>();

function* putGaAddToShoppingList(productId: WishlistItem['code']) {
  yield put(
    gaAddToShoppingList({
      elementType: 'button',
      elementBlock: 'productDetail',
      elementName: 'shoppingList',
      productTag: yield call(selectProductPriceCategory),
      productName: yield call(selectProductName),
      productPrice: yield call(selectProductPrice),
      productBelong: yield call(selectProductBelong),
      brand: (yield call(selectProductBrand)) as string,
      category: ((yield call(selectCompareCategory)) as CompareCategory)?.name || '',
      productId,
      productPrevPrice: yield call(selectProductPricePrevious),
      productDiscount: yield call(selectProductDiscount),
    }),
  );
}

export function* runAddToShoppingListDetector() {
  yield takeEvery(
    ADD_TO_SHOPPING_LIST_REQUEST,
    function* handle({ payload }: ActionType<typeof ADD_TO_SHOPPING_LIST_REQUEST>) {
      const isInWishList: boolean = yield select(getIsInWishList, payload);

      if (!isInWishList) {
        yield putGaAddToShoppingList(payload);
      }
    },
  );
}
